import moment from 'moment';
import { Loader } from '../Widgets';
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import ArthaGateway from "service/ArthaGateway";
import Swal from 'sweetalert2';
import { NavLink } from 'react-router-dom';
import { batch, useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Session } from 'service';

export const Indent = () => {

    const appdata = useSelector((state: RootState) => state.appdata);
    const [session, setSession] = useState<Session>();
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [indent, setIndent] = React.useState<any>(null);

    const navigate = useNavigate();
    const params = useParams();
    const indentId = params.id ? parseInt(params.id) : 0;

    useEffect(() => {
        if (appdata.profile) {
            setSession(appdata.profile.profile);
        }
    }, [appdata]);

    useEffect(() => {
        loadIndent();
    }, [indentId]);

    const loadIndent = () => {
        if (!indentId || indentId <= 0) {
            return;
        }

        ArthaGateway.getLoadingIndent(indentId)
            .then((response) => {
                setIndent(response);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching indent:", error);
                setIsLoading(false);
            });
    };

    const handleMarkAsLoaded = async () => {
        if (!indent) return;

        let dispatchQuantity = indent.items.reduce((total, item) => total + (item.dispatchQuantity || 0), 0);
        if (dispatchQuantity <= 0) {
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Please enter dispatch quantities for at least one item.',
            });
            return;
        }
        indent.status = "Loaded";
        indent.loadingDate = moment().format("YYYY-MM-DD");
        indent.loadedBy = session?.user.id || 1;
        ArthaGateway.saveLoadingIndent(indent, session?.user.id || 1)
            .then(() => {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Indent marked as loaded successfully.',
                    timerProgressBar: true,
                    timer: 2000
                });
                navigate("/indents");
            })
            .catch((error) => {
                console.error("Error marking indent as loaded:", error);
            });
    };

    return (
        <div className="page-indent">
            <NavLink className="btn btn-danger btn-sm float-end" to="/indents">Back to List</NavLink>
            <h1>Indent</h1>
            {isLoading && <Loader />}

            {!isLoading && indent && (
                <div className="card">
                    <div className="card-header">
                        <h2 className="m-0 float-start">{indent.voucherNumber}</h2>
                    </div>
                    <div className="card-body pt-2 pb-0">
                        <div className="card-body p-0">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item py-1">
                                    <div>Date: </div>
                                    <div className="fw-bold">{moment(indent.date).format("DD MMM YYYY")}</div>
                                </li>
                                <li className="list-group-item py-1">
                                    <div>Production Plant: </div>
                                    <div className="fw-bold">{indent.plantName}</div>
                                </li>
                                <li className="list-group-item py-1">
                                    <div>Party: </div>
                                    <div className="fw-bold">{indent.party.name}</div>
                                </li>
                                <li className="list-group-item py-1">
                                    <div>Destination:</div>
                                    <div className="fw-bold">{indent.shippingCity}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <hr />
                    <div className='card-body p-0'>
                        {indent.items && indent.items.length > 0 ? (
                            <ul className="list-group list-group-flush">
                                {indent.items.map((item, index) => (
                                    <li className="list-group-item py-1" key={index}>
                                        <div className="fw-bold">{item.product.name}</div>
                                        <div>
                                            <div className="row g-2 align-items-end">
                                                {/* Quantity (readonly) */}
                                                <div className="col-6 col-md-4">
                                                    <label htmlFor="qty" className="form-label mb-1 small">Quantity</label>
                                                    <input id="qty" name="qty" type="number" className="form-control" value={item.quantity} disabled readOnly aria-readOnly="true" />
                                                </div>

                                                {/* Dispatch Quantity (number) */}
                                                <div className="col-6 col-md-4">
                                                    <label htmlFor="dispatchQty" className="form-label mb-1 small">Dispatch Quantity</label>
                                                    <input id="dispatchQty" name="dispatchQty" type="number" className="form-control"
                                                        min="0" max={item.quantity} step="1" placeholder="Enter dispatch qty" value={item.dispatchQuantity} onChange={(e) => {
                                                            const value = e.target.value;
                                                            setIndent((prev) => {
                                                                const newItems = [...prev.items];
                                                                newItems[index] = { ...newItems[index], dispatchQuantity: (value > item.quantity) ? item.quantity : value };
                                                                return { ...prev, items: newItems };
                                                            });
                                                        }} />
                                                </div>

                                                {/* Batch Number (number) */}
                                                <div className="col-12 col-md-4">
                                                    <label htmlFor="batchNo" className="form-label mb-1 small">Batch Number</label>
                                                    <input id="batchNo" name="batchNo" type="text" className="form-control"
                                                        placeholder="Batch #" value={item.batchNumber} onChange={(e) => {
                                                            const value = e.target.value;
                                                            setIndent((prev) => {
                                                                const newItems = [...prev.items];
                                                                newItems[index] = { ...newItems[index], batchNumber: value };
                                                                return { ...prev, items: newItems };
                                                            });
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label>Remarks</label>
                                            <textarea className="form-control" rows={2} value={item.description || ''}></textarea>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div className="text-muted">No items found.</div>
                        )}
                    </div>
                    <div className="card-footer">
                        <button className="btn btn-dark btn-lg w-100" onClick={handleMarkAsLoaded}>Mark As Loaded</button>
                    </div>
                </div>
            )}
            <NavLink className="btn btn-danger btn-sm float-end mt-2" to="/indents">Back to List</NavLink>
        </div>
    );
};
